class AZIndex extends HTMLElement {
  constructor() {
    super();
    this.nav = null;
    this.buttons = [];
    this.items = [];
  }

  connectedCallback() {
    this.nav = this.querySelector('[data-index-nav]');
    this.items = Array.from(this.querySelectorAll('[data-index-item]'));

    if (!this.nav || !this.items.length) return;

    this.buttons = Array.from(this.nav.querySelectorAll('[data-index-letter]'));
    this.bindEvents();
    this.setInitialActiveButton();
    
    // Mark as JS loaded so CSS knows to hand over control
    this.setAttribute('data-js-loaded', '');
  }

  bindEvents() {
    this.buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const targetLetter = button.getAttribute('data-index-letter') || 'all';

        this.buttons.forEach((btn) => {
          btn.classList.remove('is-active');
        });
        button.classList.add('is-active');

        this.filterItems(targetLetter);
      });
    });
  }

  setInitialActiveButton() {
    const allButton = this.buttons.find((btn) => btn.getAttribute('data-index-letter') === 'all');

    this.buttons.forEach((btn) => {
      btn.classList.remove('is-active');
    });

    if (allButton) {
      allButton.classList.add('is-active');
    }

    this.filterItems('all');
  }

  filterItems(targetLetter) {
    const upperTarget = targetLetter.toUpperCase();

    this.items.forEach((item) => {
      const itemLetter =
        (item.getAttribute('data-index-item-letter') || '').toUpperCase();

      let show = false;

      if (upperTarget === 'ALL') {
        show = true;
      } else {
        show = itemLetter === upperTarget;
      }

      item.style.display = show ? '' : 'none';
    });
  }
}

customElements.define('az-index', AZIndex);
